import { FC } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ButtonPrimary from "shared/Button/ButtonPrimary";

interface InReviewState {
  type?: "stay" | "experience" | "holiday-package";
  name?: string;
}

const PageInReview: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const state = (location.state as InReviewState | null) ?? {};
  const { name } = state;

  return (
    <div className="min-h-screen w-full flex flex-col justify-center items-center bg-gray-50 px-4">
      <div className="bg-amber-100 text-amber-600 rounded-full w-20 h-20 flex items-center justify-center mb-6">
        <i className="las la-hourglass-half text-4xl"></i>
      </div>
      <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3 text-center">
        {t("translation:inReview.title")}
      </h1>
      <p className="text-base text-gray-600 max-w-md text-center mb-8">
        {name
          ? t("translation:inReview.messageWithName", { name })
          : t("translation:inReview.messageGeneric")}
      </p>
      <div className="flex flex-col sm:flex-row gap-3">
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
        >
          {t("translation:inReview.back")}
        </button>
        <ButtonPrimary href="/">
          {t("translation:inReview.home")}
        </ButtonPrimary>
      </div>
    </div>
  );
};

export default PageInReview;
